import React from 'react';
import { StyledArrow } from './styles';

interface ArrowProps {
  readonly isNextArrow?: boolean;
  onClick?: (e) => void;
  onClickThumbnail?: () => void;
  readonly className?: string;
}

export const Arrow = (props: ArrowProps) => {
  const { onClickThumbnail, isNextArrow, className, onClick } = props;

  const onHandleArrowClick = (e) => {
    onClickThumbnail && onClickThumbnail();
    onClick && onClick(e);
  };
  return (
    <StyledArrow
      onClick={onHandleArrowClick}
      className={`slick-arrow ${className ? className : ''}`}
      isNextArrow={isNextArrow}
    />
  );
};
